export default function (initialDataInteractor, organizationData) {
  initialDataInteractor.data.organizations.push(organizationData);
}